import { Pagination, Form } from "react-bootstrap";
import "../styles/custumPagination.css";
import React, { useState, useEffect ,useMemo} from "react";
const ResultsPagination = ({
  activePage,
  setActivePage,
  perPage,
  setPerPage,
  totalPages,
  perPageOptions = [] // ✅ ADD
}) => {
  const renderPages = () => {
  const pages = [];

  const startPage = Math.max(1, activePage - 1);
  const endPage = Math.min(totalPages, activePage + 1);

  // Always show first page
  if (startPage > 1) {
    pages.push(
      <Pagination.Item key={1} onClick={() => setActivePage(1)}>
        1
      </Pagination.Item>
    );

    if (startPage > 2) {
      pages.push(<Pagination.Ellipsis key="start-ellipsis" />);
    }
  }

  // Middle pages
  for (let i = startPage; i <= endPage; i++) {
    pages.push(
      <Pagination.Item
        key={i}
        active={activePage === i}
        onClick={() => setActivePage(i)}
      >
        {i}
      </Pagination.Item>
    );
  }

  // Always show last page
  if (endPage < totalPages) {
    if (endPage < totalPages - 1) {
      pages.push(<Pagination.Ellipsis key="end-ellipsis" />);
    }

    pages.push(
      <Pagination.Item
        key={totalPages}
        onClick={() => setActivePage(totalPages)}
      >
        {totalPages}
      </Pagination.Item>
    );
  }

  return pages;
};

return (
  <div
    className="d-flex justify-content-center align-items-center gap-3 flex-wrap"
    style={{ minHeight: "60px", padding: "10px 0" }}
  >

    {/* SHOW DROPDOWN */}
    <div className="d-flex align-items-center gap-2">
      <span>Show</span>

      <Form.Select
        value={perPage}
        onChange={(e) => {
          setPerPage(Number(e.target.value));
          setActivePage(1);
        }}
        style={{
          width: "90px",
          height: "40px",
          borderRadius: "50px",
        }}
      >
     {[10, 15, 20, 25, 30].map((num) => (
  <option key={num} value={num}>
    {num}
  </option>
))}
      </Form.Select>
    </div>

    {/* PAGINATION */}
    <Pagination className="mb-0 custom-pagination">
      <Pagination.Prev
        disabled={activePage === 1}
        onClick={() =>
          setActivePage((prev) => Math.max(1, prev - 1))
        }
      />

      {renderPages()}

      <Pagination.Next
        disabled={activePage === totalPages}
        onClick={() =>
          setActivePage((prev) =>
            Math.min(totalPages, prev + 1)
          )
        }
      />
    </Pagination>

  </div>
);
};

export default ResultsPagination;